/*
 * Copyright (c) 2025 Rembrand Pardo
 * Unauthorized copying, modification, or redistribution is strictly prohibited.
 * Violators will face legal action.
 */

// ../components/CertificatesData.js
//1. General
export const cards = [
    {
        title: "CPE Corporate Finance",
        src: "/certificates/Analytics/certificate_business10.jpg",
    },
    {
        title: "Business Banking",
        src: "/certificates/Analytics/certificate_business12.jpg",
    },
    {
        title: "Negotiation",
        src: "/certificates/Management/certificate_management5.jpg",
    },
    {
        title: "CFI Corporate Finance",
        src: "/certificates/Analytics/certificate_business9.jpg",
    },
    {
        title: "Microsoft and LinkedIn",
        src: "/certificates/Management/certificate_management17.jpg",
    },
    {
      title: "Zendesk: Customer Service",
      src: "/certificates/Other/certificate_other0.jpg",
    },
    {
        title: "Managing Stakeholders",
        src: "/certificates/Management/certificate_management3.jpg",
    },
    {
        title: "PM Microsoft",
        src: "/certificates/Management/certificate_management4.jpg",
    },
    {
        title: "PM Budget",
        src: "/certificates/Management/certificate_management6.jpg",
    },
    {
        title: "Financial Forecasting",
        src: "/certificates/Management/certificate_management21.jpg",
    },
    {
        title: "Business Analysis for PM",
        src: "/certificates/Analytics/certificate_business0.jpg",
    },
    {
        title: "Business Analytics",
        src: "/certificates/Analytics/certificate_business3.jpg",
    },
    {
        title: "Supply Chain",
        src: "/certificates/Analytics/certificate_business4.jpg",
    },
    {
        title: "Business IBA",
        src: "/certificates/Analytics/certificate_business5.jpg",
    },
    {
        title: "Business Project Management IBA",
        src: "/certificates/Analytics/certificate_business6.jpg",
    },
    {
        title: "Strategic Planning",
        src: "/certificates/Analytics/certificate_business8.jpg",
    },
    {
        title: "Financial Forecasting Analysis",
        src: "/certificates/Analytics/certificate_business11.jpg",
    },
    {
        title: "PM Integration",
        src: "/certificates/Management/certificate_management7.jpg",
    },
    {
        title: "Project Management",
        src: "/certificates/Management/certificate_management8.jpg",
    },
    {
        title: "PM: Government Projects",
        src: "/certificates/Management/certificate_management9.jpg",
    },
    {
        title: "Agile with Microsoft",
        src: "/certificates/Management/certificate_management0.jpg",
    },
    {
        title: "Atlassian Agile",
        src: "/certificates/Management/certificate_management1.jpg",
    },
    {
      title: "HR Certification Institute",
      src: "/certificates/Recruitment/certificate_recruitment8.jpg",
    },
    {
        title: "Human Resources Admin.",
        src: "/certificates/Recruitment/certificate_recruitment0.jpg",
    },
    {
        title: "Managing Hiring",
        src: "/certificates/Management/certificate_management2.jpg",
    },
    
    
    {
      title: "DevOps: CI/CD",
      src: "/certificates/Other/certificate_other1.jpg",
    },
    {
      title: "Cisco Networking",
      src: "/certificates/Other/certificate_other2.jpg",
    },
    {
      title: "Cisco Foundations",
      src: "/certificates/Other/certificate_other3.jpg",
    },
    {
      title: "Corporate Recruting",
      src: "/certificates/Recruitment/certificate_recruitment1.jpg",
    },
    {
      title: "Human Resources",
      src: "/certificates/Recruitment/certificate_recruitment2.jpg",
    },
    {
      title: "American Staffing Association",
      src: "/certificates/Recruitment/certificate_recruitment3.jpg",
    },
    {
      title: "Human Resources: Payroll",
      src: "/certificates/Recruitment/certificate_recruitment4.jpg",
    },
    {
      title: "Human Resources Strategy",
      src: "/certificates/Recruitment/certificate_recruitment5.jpg",
    },
    {
      title: "Interviewing Candidates",
      src: "/certificates/Recruitment/certificate_recruitment6.jpg",
    },
    {
      title: "Interviewing Techniques",
      src: "/certificates/Recruitment/certificate_recruitment7.jpg",
    },
    {
        title: "PM Leader Skills",
        src: "/certificates/Management/certificate_management10.jpg",
    },
    {
        title: "PM Technical Projects",
        src: "/certificates/Management/certificate_management11.jpg",
    },
    {
        title: "PM: Business Analysis",
        src: "/certificates/Management/certificate_management12.jpg",
    },
    {
        title: "Project Resource Management",
        src: "/certificates/Management/certificate_management13.jpg",
    },
    {
        title: "SRUM: Advance",
        src: "/certificates/Management/certificate_management14.jpg",
    },
    {
        title: "Business Analysis",
        src: "/certificates/Management/certificate_management15.jpg",
    },
    {
        title: "PM and Business Analysis",
        src: "/certificates/Management/certificate_management16.jpg",
    },

    {
        title: "Product Manager Communication",
        src: "/certificates/Management/certificate_management18.jpg",
    },
    {
        title: "PM Data Driven",
        src: "/certificates/Management/certificate_management19.jpg",
    },
    {
        title: "Adobe Analysis",
        src: "/certificates/Management/certificate_management20.jpg",
    },
    {
        title: "Strategy Analysis",
        src: "/certificates/Analytics/certificate_business1.jpg",
    },
    {
        title: "Google Analytics",
        src: "/certificates/Analytics/certificate_business2.jpg",
    },
    {
        title: "Marketing Data",
        src: "/certificates/Analytics/certificate_business7.jpg",
    },

];

//2. Software
export const othercards = [
    {
        title: "Zendesk: Customer Service",
        src: "/certificates/Other/certificate_other0.jpg",
    },
    {
        title: "DevOps: CI/CD",
        src: "/certificates/Other/certificate_other1.jpg",
    },
    {
        title: "Cisco Networking",
        src: "/certificates/Other/certificate_other2.jpg",
    },
    {
        title: "Cisco Foundations",
        src: "/certificates/Other/certificate_other3.jpg",
    }

];

//3. Hr_recruitment
export const recruitmentcards = [
    {
        title: "Human Resources Admin.",
        src: "/certificates/Recruitment/certificate_recruitment0.jpg",
      },
      {
        title: "Corporate Recruting",
        src: "/certificates/Recruitment/certificate_recruitment1.jpg",
      },
      {
        title: "Human Resources",
        src: "/certificates/Recruitment/certificate_recruitment2.jpg",
      },
      {
        title: "American Staffing Association",
        src: "/certificates/Recruitment/certificate_recruitment3.jpg",
      },
      {
        title: "Human Resources: Payroll",
        src: "/certificates/Recruitment/certificate_recruitment4.jpg",
      },
      {
        title: "Human Resources Strategy",
        src: "/certificates/Recruitment/certificate_recruitment5.jpg",
      },
      {
        title: "Interviewing Candidates",
        src: "/certificates/Recruitment/certificate_recruitment6.jpg",
      },
      {
        title: "Interviewing Techniques",
        src: "/certificates/Recruitment/certificate_recruitment7.jpg",
      },
      {
        title: "HR Certification Institute",
        src: "/certificates/Recruitment/certificate_recruitment8.jpg",
    }
];


//4. Analytics
export const analysiscards = [
    {
        title: "Business Analysis",
        src: "/certificates/Analytics/certificate_business0.jpg",
    },
    {
        title: "Strategy Analysis",
        src: "/certificates/Analytics/certificate_business1.jpg",
    },
    {
        title: "Google Analytics",
        src: "/certificates/Analytics/certificate_business2.jpg",
    },
    {
        title: "Business Analytics",
        src: "/certificates/Analytics/certificate_business3.jpg",
    },
    {
        title: "Adobe Analysis",
        src: "/certificates/Management/certificate_management20.jpg",
    },
    {
        title: "QAS Business Analysis",
        src: "/certificates/Management/certificate_management12.jpg",
    },
    {
        title: "Business IBA",
        src: "/certificates/Analytics/certificate_business5.jpg",
    },
    {
        title: "Business Project Management IBA",
        src: "/certificates/Analytics/certificate_business6.jpg",
    },
    {
        title: "Marketing Data",
        src: "/certificates/Analytics/certificate_business7.jpg",
    },
    {
        title: "Strategic Planning",
        src: "/certificates/Analytics/certificate_business8.jpg",
    },
    {
        title: "CFI Corporate Finance",
        src: "/certificates/Analytics/certificate_business9.jpg",
    },
    {
        title: "CPE Corporate Finance",
        src: "/certificates/Analytics/certificate_business10.jpg",
    },
    {
        title: "Financial Forecasting Analysis",
        src: "/certificates/Analytics/certificate_business11.jpg",
    },
    {
        title: "Business Banking",
        src: "/certificates/Analytics/certificate_business12.jpg",
    },
    {
        title: "PM and Business Analysis",
        src: "/certificates/Management/certificate_management16.jpg",
    },
    {
        title: "Supply Chain",
        src: "/certificates/Analytics/certificate_business4.jpg",
    },

];

//5. Management
export const managementcards = [
    {
        title: "Agile with Microsoft",
        src: "/certificates/Management/certificate_management0.jpg",
    },
    {
        title: "Atlassian Agile",
        src: "/certificates/Management/certificate_management1.jpg",
    },
    {
        title: "Managing Hiring",
        src: "/certificates/Management/certificate_management2.jpg",
    },
    {
        title: "Managing Stakeholders",
        src: "/certificates/Management/certificate_management3.jpg",
    },
    {
        title: "PM Microsoft",
        src: "/certificates/Management/certificate_management4.jpg",
    },
    {
        title: "Zendesk: Customer Service",
        src: "/certificates/Other/certificate_other0.jpg",
    },
    {
        title: "Negotiation",
        src: "/certificates/Management/certificate_management5.jpg",
    },
    {
        title: "PM Budget",
        src: "/certificates/Management/certificate_management6.jpg",
    },
    {
        title: "PM Integration",
        src: "/certificates/Management/certificate_management7.jpg",
    },
    {
        title: "Project Management",
        src: "/certificates/Management/certificate_management8.jpg",
    },
    
    {
        title: "PM Leader Skills",
        src: "/certificates/Management/certificate_management10.jpg",
    },
    {
        title: "PM Technical Projects",
        src: "/certificates/Management/certificate_management11.jpg",
    },
    {
        title: "QAS Business Analysis",
        src: "/certificates/Management/certificate_management12.jpg",
    },
    {
        title: "Project Resource Management",
        src: "/certificates/Management/certificate_management13.jpg",
    },
    {
        title: "SRUM: Advance",
        src: "/certificates/Management/certificate_management14.jpg",
    },
    {
        title: "Business Analysis",
        src: "/certificates/Management/certificate_management15.jpg",
    },
    {
        title: "PM and Business Analysis",
        src: "/certificates/Management/certificate_management16.jpg",
    },
    {
        title: "Microsoft and LinkedIn",
        src: "/certificates/Management/certificate_management17.jpg",
    },
    {
        title: "Product Manager Communication",
        src: "/certificates/Management/certificate_management18.jpg",
    },
    {
        title: "PM Data Driven",
        src: "/certificates/Management/certificate_management19.jpg",
    },
    {
        title: "Adobe Analysis",
        src: "/certificates/Management/certificate_management20.jpg",
    },
    {
        title: "Financial Forecasting",
        src: "/certificates/Management/certificate_management21.jpg",
    }
];
